import { c as _c } from "react/compiler-runtime";
import styled, { css } from 'styled-components';
import { Div, StyledUtilsProps } from '../helpers/StyledUtils';
import { ReactNode } from 'react';
interface Props extends StyledUtilsProps {
  options: {
    label: ReactNode;
    key: string | boolean;
  }[];
  active: string | boolean;
  onSelect: (key: string | boolean) => void;
  small?: boolean;
  full_width?: boolean;
}
const StyledTextSwitchWrapper = styled(Div)<{
  $full_width?: boolean;
}>`
  display: inline-flex;
  gap: ${({
  theme
}) => theme.spacing(0.25)};
  background-color: ${({
  theme
}) => theme.colors.surface.base.variant_surface_2};
  border: ${({
  theme
}) => theme.border};
  border-radius: ${({
  theme
}) => theme.radius.normal};

  ${({
  $full_width
}) => $full_width && css`
      width: 100%;

      > button {
        flex: 1;
      }
    `}
`;
const StyledTextSwitch = styled.button<{
  active: boolean;
  small?: boolean;
}>(({
  theme,
  active,
  small
}) => css`
    border: none;
    background-color: unset;
    position: relative;

    white-space: nowrap;
    font-size: ${small ? theme.font_sizes.xs.font_size : theme.font_sizes.m.font_size}px;
    line-height: ${theme.pxToRem(theme.font_sizes.m.line_height)};
    font-weight: ${theme.font_weights.medium};
    padding: ${small ? 0 : theme.spacing(1)} ${theme.spacing(2)};
    text-decoration: none;
    color: ${active ? theme.colors.on.neutral.primary_neutral : theme.colors.on.neutral.secondary_neutral};

    border-radius: ${theme.radius.normal_inset};
    &:hover,
    & > *:hover {
      color: ${theme.colors.on.neutral.primary_neutral};
      cursor: pointer;
    }
    ${active && css`
      box-shadow: ${({
  theme
}) => theme.shadows.neutral.base};
      background-color: ${theme.colors.surface.base.surface};
    `};
  `);
const TextSwitch = t0 => {
  const $ = _c(19);
  let active;
  let full_width;
  let onSelect;
  let options;
  let props;
  if ($[0] !== t0) {
    ({
      options,
      active,
      onSelect,
      full_width,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = active;
    $[2] = full_width;
    $[3] = onSelect;
    $[4] = options;
    $[5] = props;
  } else {
    active = $[1];
    full_width = $[2];
    onSelect = $[3];
    options = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== active || $[7] !== onSelect || $[8] !== options || $[9] !== props) {
    let t2;
    if ($[11] !== active || $[12] !== onSelect || $[13] !== props) {
      t2 = option => <StyledTextSwitch type="button" key={String(option.key)} active={option.key === active} onClick={() => onSelect(option.key)} small={props.small}>{option.label}</StyledTextSwitch>;
      $[11] = active;
      $[12] = onSelect;
      $[13] = props;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    t1 = options.map(t2);
    $[6] = active;
    $[7] = onSelect;
    $[8] = options;
    $[9] = props;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[15] !== full_width || $[16] !== props || $[17] !== t1) {
    t2 = <StyledTextSwitchWrapper $full_width={full_width} {...props}>{t1}</StyledTextSwitchWrapper>;
    $[15] = full_width;
    $[16] = props;
    $[17] = t1;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  return t2;
};
export default TextSwitch;